import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ApiError } from "@/api/client";
import { App } from "./App";
import "./styles/globals.css";
// Import firebase.ts for its init side effect. Kept explicit rather than
// relying on transitive imports so the order is obvious.
import "@/auth/firebase";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 401s from /api/* mean the token expired or the caller isn't a team
      // member — retrying won't help.
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
          return false;
        }
        return failureCount < 2;
      },
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
    mutations: { retry: false },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
